import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Util } from '../../../../../utils/util';
import { PixKeyType } from '../../../models/key-type.enum';
import { PixPaymentFavoredView } from '../../../models/payment-favored-view.model';
import { PixPaymentKeyService } from '../../payment-key.service';

@Component({
	selector: 'app-pix-payment-key-favored-create-resume',
	templateUrl: './resume.component.html',
	styleUrls: ['./resume.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixPaymentKeyFavoredCreateResumeComponent implements OnInit {

	public selectedPixPaymentFavoredView: PixPaymentFavoredView;
	disabledButton: boolean;

	get buttonTitle(): string{
		if(this.originalValueIsZero){
			return'voltar';
		}

		return 'cancelar'
	}

	constructor(
		private router: Router,
		private pixPaymentKeyService: PixPaymentKeyService,
	) {}

	ngOnInit(): void {
		this.selectedPixPaymentFavoredView = this.pixPaymentKeyService.getSelectedPixPaymentFavoredView();
		this.invalidParams() ? this.goBack() : '';

	}

	invalidParams(): boolean {
		return this.selectedPixPaymentFavoredView === undefined ||
			this.selectedPixPaymentFavoredView.tipoChave === undefined ||
			(this.selectedPixPaymentFavoredView.tipoChave !== PixKeyType.MANUAL && this.selectedPixPaymentFavoredView.codigo === undefined) ||
			(this.selectedPixPaymentFavoredView.tipoChave === PixKeyType.MANUAL && this.selectedPixPaymentFavoredView.numeroAgencia === undefined || this.selectedPixPaymentFavoredView.numeroConta === undefined)
	}

	get keyType(): typeof PixKeyType {
		return PixKeyType;
	}

	getCpfCnpj(cpfCnpj: string) {
		return Util.maskCpfCnpjPix(cpfCnpj);
	}

	goBack(){
		if(this.originalValueIsZero){
			this.router.navigate(['pix/pagamento/favorecido/adicionar/valor-data']);
			return;
		}

		this.router.navigate(['pix/pagamento/']);
	}

	get originalValueIsZero(){
		return this.selectedPixPaymentFavoredView.valorQrCode === 0;
	}

	setDisableButton(value: boolean): void{
		this.disabledButton = value;
	}

	generate = () => this.router.navigate(['pix/pagamento/favorecido/adicionar/assinatura']);
	goToValueDatePage = () => this.router.navigate(['pix/pagamento/favorecido/adicionar/valor-data']);
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/payment-key/favored-create/resume/resume.component.ts